import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { ReactNode } from "react";

interface ProtectedRouteProps {
  children?: ReactNode;
}

export const ProtectedRoute = ({
  children,
}: ProtectedRouteProps): JSX.Element => {
  const { user }: { user: any } = useAuth();
  console.log("user", user);
  
  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }
  if (user && !children) {
    return <Navigate to="/dashboard/home" replace />;
  } else {
    return <>{children}</>;
  }
};
